// Product Slider - Thumbnails

document.addEventListener("DOMContentLoaded", function () {

  var main = new Splide( '#main-carousel', {
    type: 'fade',
    rewind: true,
    pagination: false,
    arrows: false,
  });

  var thumbnails = new Splide( '#thumbnail-carousel', {
    fixedWidth: 75,
    fixedHeight: 75,
    heightRatio: 1,
    cover: true,
    gap: 10,
    perPage: 4,
    rewind: true,
    pagination: false,
    isNavigation: true,
    arrows: false,
    focus: 'center',
    direction : 'ltr',
    breakpoints: {
      788: {
        direction: 'ttb',
        perPage: 5,
        fixedWidth: 75,
        fixedHeight: 75,
      },
      480: {
        direction: 'ttb',
        perPage: 5,
        fixedWidth: 50,
        fixedHeight: 50,
      },
    },
  });
  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();
});

// Slider Image Change when Colour Swatch has been clicked

document.querySelectorAll('.color-swatch input').forEach((c) => {
  c.addEventListener('click', () => {
    let img = c.getAttribute('img');
    document.querySelectorAll('#thumbnail-carousel-track li').forEach((t) => {
        let slide = t;
        slide_color = t.getAttribute('color');
        if (slide_color === img) {
          slide.click();      
        }
    });
  });
});

// MAKE ONE FOR THE DROP DOWN TOO AND DEFAULT TO SCROLL DOWN TO IT